import { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface CalendarBookingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CalendarBookingModal({ isOpen, onClose }: CalendarBookingModalProps) {
  useEffect(() => {
    if (isOpen) {
      // Load GHL booking script when modal opens
      const script = document.createElement("script");
      script.src = "https://link.mosheli.com/js/form_embed.js";
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);

      return () => {
        // Cleanup script when modal closes
        document.body.removeChild(script);
      };
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
            Schedule a Call
          </DialogTitle>
        </DialogHeader>
        
        <div className="mt-4">
          <iframe
            src="https://link.mosheli.com/widget/booking/3sn4XnAfiTTkFs5mV1p7"
            style={{ width: "100%", border: "none", overflow: "hidden", minHeight: "600px" }}
            scrolling="no"
            id="3sn4XnAfiTTkFs5mV1p7_1763424761459"
            title="Schedule a Call"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
